import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-news-feed',
  templateUrl: './news-feed.component.html',
  styleUrls: ['./news-feed.component.scss']
})
export class NewsFeedComponent implements OnInit {

  @Output() messageEvent = new EventEmitter<any>();
  @Input() listaNews: any[];
  
  message: string;
  label: string;
  editaNews:boolean=false;

  constructor(
    private apiService: ApiService,
    public globalService : GlobalService
  ) { }

  ngOnInit() {
    this.message = 'Comunicazione importante';
    this.label = 'LEGGI ORA';
    let logInfo = JSON.parse(localStorage.getItem("logInfo"));
    if(logInfo.ABIL_INS_NEWS='S'){
      this.editaNews=true;
    }

  }
  updatenews($event){
    
    this.messageEvent.emit($event);
  }

  addnew(){
    let logInfo = JSON.parse(localStorage.getItem("logInfo"));
    let params={
      oper:2,
      redirectS:'DBServlet',
      password:logInfo.password,
      userNamelogin:logInfo.username
    }
    this.globalService.submitForm('arkiweb/login/LogonServletAw','POST',params);
  
  }
}
